import { soActionTypes } from '@Actions/sales/soActions';

const SOReducers = (state = {}, action) => {
  switch (action.type) {
    case soActionTypes.GET_SO.LOADING: {
      const { getSOLoading, orderType } = action;
      if (orderType === 'SALES_ESTIMATE') {
        return {
          ...state,
          getEstimateLoading: getSOLoading,
        };
      }else if (orderType === 'PACKING_SLIP') {
        return {
          ...state,
          getPSLoading: getSOLoading,
        };
      }else {
        return {
          ...state,
          getSOLoading,
        };
      }
    }
    case soActionTypes.GET_SO.SUCCESS: {
      const { salesOrders, orderType } = action;
      if (orderType === 'SALES_ESTIMATE') {
        return {
          ...state,
          salesEstimate: salesOrders,
        };
      } else if (orderType === 'PACKING_SLIP') {
        return {
          ...state,
          packingSlips: salesOrders,
        };
      }else {
        return {
          ...state,
          salesOrders,
        };
      }
    }
    case soActionTypes.GET_SO_BY_ID.LOADING: {
      const { getSOByIdLoading } = action;
      return {
        ...state,
        getSOByIdLoading,
      };
    }
    case soActionTypes.GET_SO_BY_ID.SUCCESS: {
      const { selectedSO } = action;
      return {
        ...state,
        selectedSO,
      };
    }
    case soActionTypes.CREATE_SO.LOADING: {
      const { createSOLoading } = action;
      return {
        ...state,
        createSOLoading,
      };
    }
    case soActionTypes.UPDATE_SO.LOADING: {
      const { updateSOLoading } = action;
      return {
        ...state,
        updateSOLoading,
      };
    }
    case soActionTypes.UPDATE_STATUS_SO.LOADING: {
      const { updateSOStatusLoading } = action;
      return {
        ...state,
        updateSOStatusLoading,
      };
    }

    case soActionTypes.UPDATE_BUNDLE.LOADING: {
      const { updateBundleLinesLoading } = action;
      return {
        ...state,
        updateBundleLinesLoading,
      };
    }
    case soActionTypes.DELETE_BUNDLE_LINE.LOADING: {
      const { deleteBundleLinesLoading } = action;
      return {
        ...state,
        deleteBundleLinesLoading,
      };
    }
    case soActionTypes.DELETE_SO.LOADING: {
      const { deleteSOLoading } = action;
      return {
        ...state,
        deleteSOLoading,
      };
    }
    case soActionTypes.UPDATE_SO_WORKFLOW_STEP.LOADING: {
      const { updateSOWorkflowStepLoading } = action;
      return {
        ...state,
        updateSOWorkflowStepLoading,
      };
    }
    case soActionTypes.UPDATE_FULFILLMENT_LOCATION.LOADING: {
      const { updateFulfillmentLocationLoading } = action;
      return {
        ...state,
        updateFulfillmentLocationLoading,
      };
    }
    case soActionTypes.FULFILL_UF_FO.LOADING: {
      const { fulfillUnfulfilledOrderLoading } = action;
      return {
        ...state,
        fulfillUnfulfilledOrderLoading,
      };
    }
    case soActionTypes.CANCEL_FULFILLMENT.LOADING: {
      const { cancelFulfillmentLoading } = action;
      return {
        ...state,
        cancelFulfillmentLoading,
      };
    }
    case soActionTypes.CREATE_RETURN_FULFILLMENT.LOADING: {
      const { createReturnFulfillmentLoading } = action;
      return {
        ...state,
        createReturnFulfillmentLoading,
      };
    }
    case soActionTypes.CANCEL_RETURN_FULFILLMENT.LOADING: {
      const { cancelReturnFulfillmentLoading } = action;
      return {
        ...state,
        cancelReturnFulfillmentLoading,
      };
    }
    case soActionTypes.GET_RETURN_FULFILLMENT.LOADING: {
      const { getReturnFulfillmentLoading } = action;
      return {
        ...state,
        getReturnFulfillmentLoading,
      };
    }
    case soActionTypes.GET_RETURN_FULFILLMENT.SUCCESS: {
      const { returnFulfillments } = action;
      return {
        ...state,
        returnFulfillments,
      };
    }
    case soActionTypes.CREATE_REFUND.LOADING: {
      const { createRefundLoading } = action;
      return {
        ...state,
        createRefundLoading,
      };
    }
    case soActionTypes.GET_RETURNS.LOADING: {
      const { getReturnsLoading } = action;
      return {
        ...state,
        getReturnsLoading,
      };
    }
    case soActionTypes.GET_RETURNS.SUCCESS: {
      const { shopifyReturns } = action;
      return {
        ...state,
        shopifyReturns,
      };
    }
    case soActionTypes.DOWNLOAD_SALES_ORDERS.LOADING: {
      const { downloadSalesOrderLoading } = action;
      return {
        ...state,
        downloadSalesOrderLoading,
      };
    }
    case soActionTypes.CONVERT_SO_TO_MO.LOADING: {
      const { convertSoToMoLoading } = action;
      return {
        ...state,
        convertSoToMoLoading,
      };
    }
    case soActionTypes.GET_SO_AVAILABILITY.LOADING: {
      const { getSoAvailabilityLoading } = action;
      return {
        ...state,
        getSoAvailabilityLoading,
      };
    }
    case soActionTypes.GET_SO_AVAILABILITY.SUCCESS: {
      const { soAvailability } = action;
      return {
        ...state,
        soAvailability,
      };
    }
    case soActionTypes.DOWNLOAD_SO_LIST.LOADING: {
      const { downloadSoListLoading } = action;
      return {
        ...state,
        downloadSoListLoading,
      };
    }
    // unlink so and mo
    case soActionTypes.UNLINK_MO_SO.LOADING: {
      const { unLinkMOFromSOLoading } = action;
      return {
        ...state,
        unLinkMOFromSOLoading,
      };
    }

    default: {
      return state;
    }
  }
};

export default SOReducers;
